<!--按钮组件-->
<template>
    <div :style="{'color':`${fontColor}`,'backgroundColor':`${bgColor}`}"
         :class="{'rButtonWrapper':true,'textPadding':fontColor&&bgColor,'white':color=='white','gray':color=='gray','theme':color=='theme','themeBig':color=='themeBig','grayBig':color==='grayBig','noBg':color==='reload','default':color=='default','ghost':color=='ghost','tags':color=='tags','un_interest': color=='un_interest', 'interest': color=='interest', 'tourType':color=='tourType','tourTypeGhost':color=='tourTypeGhost','selectTour':color=='selectTour','tourTags':color==='tourTags','scrollTourTags':color==='scrollTourTags', 'viewMore': color==='viewMore'}"
         @click="onClick">
        <slot></slot>
    </div>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import $ from "jquery";

    export default {
        name: "RButton",
        components: {},
        props: {

            color: {
                type: String,
                default: "white"
            },
            type: {
                type: String,
                default: ""
            },
            fontColor: {
                type: String,
                default: ""
            },
            bgColor: {
                type: String,
                default: ""
            }

        },
        data() {
            return {};

        },
        mounted() {

        },
        methods: {
            onClick() {
                this.$emit("on-click");

            }

        }
    };
</script>
<style lang="less">
    @import "../../assets/less/common";

    .rButtonWrapper {
        font-size: .35rem;
        padding: .22rem .7rem;
        background: #fff;
        color: #FFF;
        border-radius: 1rem;
        text-align: center;
        cursor: pointer;

        flex: 0 0 auto;
        margin-right: .25rem;
        display: inline-block;
        position: relative;
        img{
            width: .4rem;
            height: .4rem;
            position: relative;
            top: .066rem;
            margin: 0 .15rem;
        }
    }


    .textPadding {
        padding: .2rem .3rem;
    }

    //基础按钮
    .noBg {
        color: @primary-color;
        background: #fff;
        box-shadow: none !important;

    }

    .default {
        background: rgba(255, 255, 255, 1);
        border: .02rem  solid rgba(238, 242, 249, 1);
        color: #646772;
        box-shadow: none;
        width: 2.4rem;
        padding: .2rem .1rem;
        margin: .18rem;
    }

    .ghost {
        background: rgba(255, 255, 255, 1);
        border: .02rem solid @primary-color;
        color: @primary-color;
        width: 2.4rem;
        padding: .2rem .1rem;
        margin: .18rem;
    }

    .gray {
        background: rgba(233, 238, 250, 1);;
        margin: .1rem 0;
        color: #4D5772;
        width: 3.6rem;
        padding: .25rem .1rem;
    }

    .grayBig {
        color: #666;
        padding: .36rem .8rem;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
        width: 3.8rem;
    }

    .white {
        background: #fff;
        color: #666;
    }

    //功能按鈕
    //主题颜色按钮
    .theme {
        background: @primary-color;
        margin: .1rem 0;
        color: #fff;
        width: 3.6rem;
        padding: .25rem .1rem;
    }
    //主题颜色大按钮
    .themeBig {
        color: rgba(55, 109, 255, 1);
        padding: .36rem 1.3rem;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
        width: 3.8rem;
    }

    //不感兴趣 不想看了
    .un_interest{
        background: @light-color;
        margin: .1rem 0;
        color: @font-base-color;
        width: 3.6rem;
        padding: .25rem .1rem;
    }
    // 感兴趣 我想看看
    .interest{
        background: @primary-color;
        margin: .1rem 0;
        color: #fff;
        width: 3.6rem;
        padding: .25rem .1rem;
    }

    .tags {
        background: rgba(247, 252, 255, 1);
        color: @primary-color;
        opacity: .8;
        border: .02px solid rgba(228, 240, 255, 1);
        padding: .1rem .15rem;
       margin-top: .12rem;
        margin-bottom: .12rem;
    }

    .tourType {
        box-shadow: none;
        color: #646772;
        border-radius: .2rem;
        border: .02rem  solid rgba(238, 242, 249, 1);
        width: 3.6rem;
        padding: .25rem .2rem;
        margin: .2rem 0;
    }

    .tourTypeGhost {
        box-shadow: none;
        color: #646772;
        border-radius: .2rem;

        border: .02rem  solid @primary-color;
        width: 3.6rem;
        padding: .25rem .2rem;
        margin: .2rem 0;
    }
    .selectTour{
        background: rgba(234,241,249,1);
        margin:0;
        color: #646772;
        padding: .2rem .1rem;
        width: 2.5rem;
    }
    .tourTags{
        background: rgba(247, 252, 255, 1);
        color: @primary-color;
        opacity: .8;
        padding: .06rem .14rem;
        margin: .12rem .2rem .12rem 0;
    }
    .scrollTourTags{
        color: rgb(108, 140, 250);
        background-color: rgb(236, 242, 255);
    }
    // 查看更多
    .viewMore{
        color: @font-dark-color;
        background-color: @light-color;
    }

</style>
